import WithdrawalPage from "./Withdrawal.jsx";

export default WithdrawalPage;
